import {IconAdd, InternalLink} from '~/components';
import {useState} from 'react';
import {Transition} from '@headlessui/react';

/**
 * A server component that specifies the content of the footer on the website
 */
export function FooterMenu({
  footerLinks,
  index,
}: {
  footerLinks?: any[];
  index?: number;
}) {
  const [activeIndex, setActiveIndex] = useState(-1);

  const handleClick = (index) => {
    setActiveIndex(index === activeIndex ? -1 : index);
  };

  return (
    <>
      {footerLinks?.map((link, index) => (
        <div
          key={index}
          className="column relative border-t md:border-t-0 custom-border"
        >
          <ul key={index}>
            <li>
              <h3
                key={link._key}
                className="md:pb-4 md:pt-0 pt-4 text-xxs flex justify-between items-center tracking-wider"
                onClick={() => handleClick(index)}
              >
                {link.colTitle}
                {activeIndex === index ? (
                  <IconAdd className="block md:hidden transition-all duration-75 rotate-45" />
                ) : (
                  <IconAdd className="block md:hidden transition-all duration-75" />
                )}
              </h3>
              <Transition
                show={activeIndex === index}
                enter="transition-opacity duration-200"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="mobile block md:hidden">
                  <LinkList
                    listClasses="pb-4 md:pb-2 text-xs"
                    className="pt-4"
                    key={index}
                    link={link.links}
                  />
                </div>
              </Transition>
            </li>
            <div className="desktop hidden md:block">
              <LinkList
                listClasses="pb-4 md:pb-2 text-xs"
                key={index}
                link={link.links}
              />
            </div>
          </ul>
        </div>
      ))}
    </>
  );
}

export function LinkList({
  link,
  listClasses,
  className,
}: {
  link?: any[];
  className?: string;
  listClasses?: string;
}) {
  return (
    <div className={className}>
      {link?.map((item, index) => (
        <li key={index} className={listClasses}>
          {item._type === 'linkInternal' && (
            <InternalLink documentType={item.documentType} slug={item.slug}>
              {item.title}
            </InternalLink>
          )}
          {item._type === 'linkExternal' && (
            <a
              href={item.url}
              target={item.newWindow ? '_blank' : ''}
              rel="noreferrer"
            >
              {item.title}
            </a>
          )}
        </li>
      ))}
    </div>
  );
}
